module.exports = "../fonts/icon_home.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_home.svg
// module id = 297
// module chunks = 0